import React from "react";
import { FaUsers } from "react-icons/fa";

const ParticipantsLabel = ({ count = 0 }) => {
  return (
    <div className="participants_label_container" style={{
      padding: '15px 20px',
      borderBottom: '1px solid #333',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    }}>
      <p className="participants_label_paragraph" style={{
        fontWeight: 600,
        color: '#fff',
        fontSize: '15px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        margin: 0
      }}>
        <FaUsers /> Participants
        <span className="participants_count" style={{
          background: 'rgba(255,255,255,0.1)',
          padding: '2px 8px',
          borderRadius: '10px',
          fontSize: '12px',
          color: '#a0a0a0'
        }}>
          {count}
        </span>
      </p>
    </div>
  );
};

export default ParticipantsLabel;
